export default class constants {
    static sessionDetails = {
        userInfo : "Posinet-User-Info"
    }
}